import type { SlotsToClasses } from "@heroui/react";
import { Icon } from '@iconify/react';
import clsx from "clsx";
import { isUndefined } from "lodash";
import type { MouseEventHandler } from "react";
import type { Collapseable } from "../types";

export interface BrandProps extends Collapseable {
    className?: string;
    classNames?: SlotsToClasses<"base" | "logo" | "nameWrapper" | "name">;
    /** 品牌名称 */
    name?: string;
    /** 品牌 Logo URL */
    logo?: React.ReactNode;
    /** 点击事件 */
    onClick?: MouseEventHandler;
}


export const Brand: React.FC<BrandProps> = ({ logo, name, className, classNames, isCollapsed, onClick }) => {

    const renderNameText = () => {
        if (!name) return null;
        if (isCollapsed) return null;
        return (
            <div className={clsx("flex items-center flex-1 min-w-0", classNames?.nameWrapper)}>
                <span className={clsx("text-small font-bold uppercase opacity-100", classNames?.name)}>
                    {name}
                </span>
            </div>
        )
    }

    const renderLogo = () => {
        if (!logo) return (
            <Icon
                icon="solar:code-square-line-duotone"
                className="text-primary-foreground"
                width={24}
            />
        )
        if (typeof logo === 'string')
            return <img src={logo} alt="VGrove" className={clsx(classNames?.logo)} />

        return logo;
    }

    return (
        <div
            className={clsx(
                "flex",
                "gap-2",
                "items-center",
                {
                    "py-2": isCollapsed,
                    "mb-2": !isCollapsed,
                    "px-3": !isCollapsed,
                    "cursor-pointer": !isUndefined(onClick)
                },
                classNames?.base,
                className
            )}
            onClick={onClick}
        >
            {renderLogo()}
            {renderNameText()}
        </div>
    )
}